import type { RxJsonSchema } from 'rxdb'
import type { PlanDocument } from '@/lib/types/subscription'

/**
 * RxDB Schema for Plan
 * Subscription plans with features and limits
 */
export const planSchema: RxJsonSchema<PlanDocument> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 36,
    },
    code: {
      type: 'string',
      maxLength: 50,
    },
    name: {
      type: 'string',
      maxLength: 100,
    },
    description: {
      type: 'string',
      maxLength: 500,
    },
    priceMonthly: {
      type: 'number',
      minimum: 0,
      maximum: 999999999,
      multipleOf: 1,
    },
    priceAnnual: {
      type: 'number',
      minimum: 0,
      maximum: 999999999,
      multipleOf: 1,
    },
    currency: {
      type: 'string',
      maxLength: 3,
    },
    limits: {
      type: 'object',
    },
    features: {
      type: 'object',
    },
    isPublic: {
      type: 'boolean',
      default: true,
    },
    sortOrder: {
      type: 'number',
      minimum: 0,
      maximum: 9999,
      multipleOf: 1,
    },
    highlightText: {
      type: ['string', 'null'],
      maxLength: 100,
    },
    ctaText: {
      type: ['string', 'null'],
      maxLength: 100,
    },
    isDeleted: {
      type: 'boolean',
      default: false,
    },

    // Audit fields
    createdOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    createdBy: {
      type: 'string',
      maxLength: 36,
    },
    updatedOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    updatedBy: {
      type: 'string',
      maxLength: 36,
    },
    deletedOn: {
      type: ['number', 'null'],
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    deletedBy: {
      type: ['string', 'null'],
      maxLength: 36,
    },

  },
  required: [
    'id',
    'code',
    'name',
    'description',
    'priceMonthly',
    'priceAnnual',
    'currency',
    'limits',
    'features',
    'isPublic',
    'sortOrder',
    'isDeleted',
    'createdOn',
    'createdBy',
    'updatedOn',
    'updatedBy',
  ],
  indexes: ['code', 'isPublic', 'sortOrder'],
}
